import { useMediaQuery } from 'react-responsive';
import { ScreenSize, screenSizeMap } from '../constants';
/**
 * A hook to return the current screen size based on CUI breakpoints
 */
var useScreenSize = function useScreenSize(customScreenSizes) {
  var isDesktop = useMediaQuery({
    minWidth: customScreenSizes !== null && customScreenSizes !== void 0 && customScreenSizes.DESKTOP ? customScreenSizes.DESKTOP : screenSizeMap.DESKTOP
  });
  var isLaptop = useMediaQuery({
    minWidth: customScreenSizes !== null && customScreenSizes !== void 0 && customScreenSizes.LAPTOP ? customScreenSizes.LAPTOP : screenSizeMap.LAPTOP
  });
  var isTablet = useMediaQuery({
    minWidth: customScreenSizes !== null && customScreenSizes !== void 0 && customScreenSizes.TABLET ? customScreenSizes.TABLET : screenSizeMap.TABLET
  });
  var isPhone = useMediaQuery({
    minWidth: customScreenSizes !== null && customScreenSizes !== void 0 && customScreenSizes.TABLET ? customScreenSizes.TABLET : screenSizeMap.PHONE
  });
  switch (true) {
    case isDesktop:
      return ScreenSize.DESKTOP;
    case isLaptop:
      return ScreenSize.LAPTOP;
    case isTablet:
      return ScreenSize.TABLET;
    case isPhone:
    default:
      return ScreenSize.PHONE;
  }
};
export default useScreenSize;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/screen/hooks/useScreenSize.js
// module id = 2577
// module chunks = 11